export default __webpack_public_path__ + "static/media/file_example_import_dialog.adeaae35.xlsx";